import { IBlueprint } from './blueprints'
import { blueprints } from './blueprints-sidecar'
import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobMine } from '../behavior/jobMine-sidecar'

function ensure(obj: IBlueprint) {
  blueprints.ensureType(obj, 'mine')
}

export function onCreate(obj: IBlueprint) {
  ensure(obj)
  obj.onUpdate = onUpdate

  let jc = jobCreators.create(
    () => {
      // Can also have asteroid spots
      // let as = asteroids.findAtSpot(obj.i, obj.j, (c) => c.supplyLeft > 0)
      // if (as) {
      //   return true
      // }
      // return false
      return true
    },
    () => {
      return jobMine.create(obj)
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IBlueprint) {
  ensure(obj)
}
